import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./lib/auth";
import AuthCallback from "./components/AuthCallback";

import HomePage from "./pages/HomePage";
import CategoryPage from "./pages/CategoryPage";
import ArticlePage from "./pages/ArticlePage";
import DealsPage from "./pages/DealsPage";
import DealPage from "./pages/DealPage";
import DestinationsPage from "./pages/DestinationsPage";
import DestinationPage from "./pages/DestinationPage";
import ReviewsPage from "./pages/ReviewsPage";
import ReviewPage from "./pages/ReviewPage";
import CreditCardsPage from "./pages/CreditCardsPage";
import VideosPage from "./pages/VideosPage";
import VideoDetailPage from "./pages/VideoDetailPage";
import BookingPage from "./pages/BookingPage";
import AboutPage from "./pages/AboutPage";
import NotFoundPage from "./pages/NotFoundPage";

import AdminLogin from "./pages/admin/AdminLogin";
import AdminLayout from "./pages/admin/AdminLayout";
import Dashboard from "./pages/admin/Dashboard";
import ArticlesList from "./pages/admin/ArticlesList";
import ArticleEditor from "./pages/admin/ArticleEditor";
import DealsAdmin from "./pages/admin/DealsAdmin";
import DestinationsAdmin from "./pages/admin/DestinationsAdmin";
import ReviewsAdmin from "./pages/admin/ReviewsAdmin";
import CardsAdmin from "./pages/admin/CardsAdmin";
import VideosAdmin from "./pages/admin/VideosAdmin";
import MediaLibrary from "./pages/admin/MediaLibrary";
import PromptTemplates from "./pages/admin/PromptTemplates";
import ContentCalendar from "./pages/admin/ContentCalendar";
import PublishLog from "./pages/admin/PublishLog";
import RevenueDashboard from "./pages/admin/RevenueDashboard";

function Router() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <>
      <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/deals" element={<DealsPage />} />
      <Route path="/deal/:slug" element={<DealPage />} />
      <Route path="/destinations" element={<DestinationsPage />} />
      <Route path="/destination/:slug" element={<DestinationPage />} />
      <Route path="/reviews" element={<ReviewsPage />} />
      <Route path="/review/:slug" element={<ReviewPage />} />
      <Route path="/credit-cards" element={<CreditCardsPage />} />
      <Route path="/videos" element={<VideosPage />} />
      <Route path="/video/:slug" element={<VideoDetailPage />} />
      <Route path="/booking" element={<BookingPage />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="/travel-hacks" element={<CategoryPage category="travel-hacks" title="Travel Hacks" />} />
      <Route path="/points-miles" element={<CategoryPage category="points-miles" title="Points & Miles" />} />
      <Route path="/airlines" element={<CategoryPage category="airlines" title="Airlines" />} />
      <Route path="/hotels" element={<CategoryPage category="hotels" title="Hotels" />} />
      <Route path="/article/:slug" element={<ArticlePage />} />

      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin" element={<AdminLayout />}>
        <Route index element={<Dashboard />} />
        <Route path="articles" element={<ArticlesList />} />
        <Route path="articles/new" element={<ArticleEditor />} />
        <Route path="articles/:id" element={<ArticleEditor />} />
        <Route path="deals" element={<DealsAdmin />} />
        <Route path="destinations" element={<DestinationsAdmin />} />
        <Route path="reviews" element={<ReviewsAdmin />} />
        <Route path="cards" element={<CardsAdmin />} />
        <Route path="videos" element={<VideosAdmin />} />
        <Route path="media" element={<MediaLibrary />} />
        <Route path="prompts" element={<PromptTemplates />} />
        <Route path="calendar" element={<ContentCalendar />} />
        <Route path="publish-log" element={<PublishLog />} />
        <Route path="revenue" element={<RevenueDashboard />} />
      </Route>

      <Route path="*" element={<NotFoundPage />} />
    </Routes>
    </>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Router />
        <Toaster richColors position="top-right" />
      </BrowserRouter>
    </AuthProvider>
  );
}
